import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { submissionSetupTokenizer } from '../store/tokens/submission-setup.token';

export const appealsResolver = async (route: ActivatedRouteSnapshot) => {
  const store = submissionSetupTokenizer();
  
  // Get workspaceId from route params (used for appeals)
  const workspaceId = route.paramMap.get('workspaceId');
  
  if (!workspaceId) {
    // If no workspaceId, just return true to allow navigation
    // The component will handle the case when workspaceId is missing
    return true;
  }

  // Load the submission by ID
  store.getSubmissionById(workspaceId);

  // Wait for the submission to be loaded
  return await firstValueFrom(
    toObservable(store.$submission).pipe(
      filter(
        (submission) => !!submission && Object.keys(submission).length > 0,
      ),
    ),
  );
};
